import { useContext, useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ModalManagementStore } from '../../providers/modal-manager';
import Button from '../../components/Button';
import GenericCard from '../../components/GenericCards/GenericCards';
import Pager from '../../components/Pager';
import Chip from '../../components/TransactionStatus/Chip';
import Link from '../../components/Link';

import {
  TransactionHistoryStore,
  TransactionHistoryProvider,
} from '../../providers/benefitAmounts';

function TableData() {
  const [currPage, setCurrPage] = useState(1);
  const { benefitAmounts } = useContext(TransactionHistoryStore);
  const { openModal } = useContext(ModalManagementStore);

  return (
    <Container className={'cnd-custom-container px-0 mt-11'}>
      <Container className={'px-7 px-lg-0 mb-7 mb-lg-7'}>
        <Row>
          <Col className={'col-8 col-lg-4'}>
            <h2 className={'text-sm-20-lg-24 mb-7 mb-lg-11'}>
              Benefit Amounts
            </h2>
          </Col>
 
        </Row>
 

      </Container>
      <GenericCard variant={'white'}>
        <Row>
          <Col>
            <Row className={'d-none d-lg-flex border-bottom-dark-gray py-8'}>
              <Col className={'d-none d-lg-block col-lg-3 text-fs-6 m-0'}>
                Plan
              </Col>
              <Col className={'col-lg-3 ps-6 m-0'}>
                <span className={'text-fs-6 ms-11'}>Dates</span>
              </Col>
              <Col className={'col-auto col-1 col-lg-3 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Form</span>
              </Col>
              <Col className={'col-auto col-lg-3 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Amount</span>
              </Col>
 
 
 
 
            </Row>
            {benefitAmounts.map((transaction, index) => {
              return (
                <Row className={'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'}
                key={index}>
                  <Col className={'px-0 px-lg-5 col-3 col-lg-3 order-0'}>
                    <span className={'h3 text-fs-6 m-0'}>
                    {transaction['plan']}
                    </span>
                  </Col>
                  <Col className={'col-3 col-lg-3 d-lg-flex align-items-start justify-content-lg-center order-1'}>
                    <span className={'d-flex align-items-center h3 text-fs-6 m-0'}>
                      {transaction['date']}
                    </span>
                  </Col>
       
                  <Col className={'col-3 col-lg-3 d-lg-flex align-items-start order-1'}>
                    <span className={'d-flex h3 text-fs-6 m-0'}>
                      {transaction['forms']}
                    </span>
                  </Col>
 
 
                  <Col className={'d-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0'}>
                    <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                      Amount
                    </h2>
                    <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                      {transaction['amount']}
                    </span>
                  </Col>
                  
                </Row>
              );
            })}
          </Col>
        </Row>
        <Container
          className={
            'px-0 mt-11 d-flex d-lg-block justify-content-center mt-11 mt-lg-10'
          }
        >
           <Button
              variant="primary"
              className={'mx-lg-10 order-3 order-lg-2 mt-7 mt-lg-0'}
               >
              Direct Deposit
            </Button>
            <Button
              variant="primary"
              className={'mx-lg-10 order-3 order-lg-2 mt-7 mt-lg-0'}
               >
              Tax Withholding
            </Button>
        </Container>
      </GenericCard>
    </Container>
  );
}

const benefitAmounts = () => {
  return (
    <TransactionHistoryProvider>
      <TableData />
    </TransactionHistoryProvider>
  );
};

export default benefitAmounts;
